<template>
</template>

<script>
import GmapUtil from '../../../utils/gmap'

export default {
    props: {
        google: { type: Object, required: true },
        map: { type: Object, required: true },
        center: { type: Object, required: true },
        objetTouristique: { type: Object, required: true },
    },

    data() {
        return {
        }
    },

    mounted() {
        this.directionsRenderer = new this.google.maps.DirectionsRenderer({
            polylineOptions: {
                strokeColor: '#ED1C24',
            },
            suppressMarkers: true,
            preserveViewport: true,
        })
        this.google.maps.event.addListener(this.directionsRenderer, 'directions_changed', () => {
            this.fitMapToBounds(this.objetTouristique.direction.routes[0].bounds)
        })
        this.renderDirection()
    },

    watch: {
        direction() {
            this.directionsRenderer.setMap(null)
            this.renderDirection()
        },
    },

    methods: {
        renderDirection() {
            // Delay displaying direction after the panel animation is over
            if (this.objetTouristique.direction) {
                if (this.objetTouristique.direction.routes.length) {
                    setTimeout(() => {
                        if (!this.objetTouristique.direction.convertedGmap) {
                            const gmapUtil = new GmapUtil(this.google)
                            gmapUtil.jsonToGmapObject(this.objetTouristique.direction)
                        }
                        this.directionsRenderer.setMap(this.map)
                        this.directionsRenderer.setDirections(this.objetTouristique.direction)
                    }, 600)
                } else {
                    // no direction, but fitbound from origin and distination
                    const bounds = new this.google.maps.LatLngBounds()
                    bounds.extend(new this.google.maps.LatLng(this.objetTouristique.direction.request.origin.location.lat, this.objetTouristique.direction.request.origin.location.lng))
                    bounds.extend(new this.google.maps.LatLng(this.objetTouristique.direction.request.destination.location.lat, this.objetTouristique.direction.request.destination.location.lng))
                    this.fitMapToBounds(bounds)
                }
            } else {
                const bounds = new this.google.maps.LatLngBounds()
                bounds.extend(new this.google.maps.LatLng(this.objetTouristique.geolocation.lat, this.objetTouristique.geolocation.long))
                bounds.extend(new this.google.maps.LatLng(this.center.lat, this.center.long))
                this.fitMapToBounds(bounds)
            }
        },

        fitMapToBounds(bounds) {
            this.map.fitBounds(bounds)
            this.map.setZoom(this.map.getZoom() - 1)
            this.map.panBy(350, 0)
        },
    },

    beforeDestroy() {
        this.directionsRenderer.setMap(null)
    },
}
</script>
